import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { Task, Priority, Status } from '../../customs/_models/taskDTO';
import { TaskService } from '../../services/task-service/task.service';
import { CommonModule, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatError, MatFormField, MatLabel, MatSelect, MatSelectModule, MatSuffix } from '@angular/material/select';
import { MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOption, MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';

export interface PeriodicElement {
    id?: number;
    taskName: string;
    dueDate: string;
    priority: string;
    status: any;
    action: any;
}

@Component({
  selector: 'app-to-do-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
        MatNativeDateModule,
        CommonModule,FormsModule,
MatAutocompleteModule,

        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
        MatSuffix, MatSortModule, MatInputModule, MatOption,MatIconModule, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription
   
  ],
  templateUrl: './to-do-list.component.html',
  styleUrls: ['./to-do-list.component.scss']
})
export class ToDoListComponent implements OnInit {

    displayedColumns: string[] = ['select', 'taskName', 'dueDate', 'priority', 'status', 'action'];
    dataSource = new MatTableDataSource<PeriodicElement>([]);
    selection = new SelectionModel<PeriodicElement>(true, []);

    taskForm: FormGroup;
    classApplied = false;
    isToggled = false;
    isEditMode = false;
    currentTaskId: number | null = null;

    priorities = ['High', 'Medium', 'Low'];
    statuses = ['In Progress', 'Pending', 'Completed', 'Not Started'];

    constructor(
        private taskService: TaskService,
        public themeService: CustomizerSettingsService,
        private fb: FormBuilder
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });

        this.taskForm = this.fb.group({
            taskName: ['', Validators.required],
            dueDate: ['', Validators.required],
            priority: ['Medium', Validators.required],
            status: ['Not Started', Validators.required]
        });
    }

    ngOnInit(): void {
        this.loadTasks();
    }

    loadTasks(): void {
        this.taskService.getAllTasks().subscribe({
            next: (tasks: Task[]) => {
                const elements: PeriodicElement[] = tasks.map(task => ({
                    taskName: task.taskName,
                    dueDate: this.formatDate(task.dueDate),
                    priority: this.mapPriority(task.priority),
                    status: this.mapStatus(task.status),
                    action: {
                        view: 'visibility',
                        edit: 'edit',
                        delete: 'delete'
                    }
                }));
                this.dataSource.data = elements;
            },
            error: (error) => {
                console.error('Erreur lors du chargement des tâches:', error);
            }
        });
    }

    mapPriority(priority: Priority): string {
        const priorityMap: { [key in Priority]: string } = {
            [Priority.HIGH]: 'High',
            [Priority.MEDIUM]: 'Medium',
            [Priority.LOW]: 'Low'
        };
        return priorityMap[priority];
    }

    mapStatus(status: Status): any {
        const statusObj: any = {
            inProgress: null,
            pending: null,
            completed: null,
            notStarted: null
        };

        switch (status) {
            case Status.IN_PROGRESS:
                statusObj.inProgress = 'In Progress';
                break;
            case Status.PENDING:
                statusObj.pending = 'Pending';
                break;
            case Status.COMPLETED:
                statusObj.completed = 'Completed';
                break;
            case Status.NOT_STARTED:
                statusObj.notStarted = 'Not Started';
                break;
        }

        return statusObj;
    }

    reverseMapPriority(priority: string): Priority {
        const priorityMap: { [key: string]: Priority } = {
            'High': Priority.HIGH,
            'Medium': Priority.MEDIUM,
            'Low': Priority.LOW
        };
        return priorityMap[priority];
    }

    reverseMapStatus(status: string): Status {
        const statusMap: { [key: string]: Status } = {
            'In Progress': Status.IN_PROGRESS,
            'Pending': Status.PENDING,
            'Completed': Status.COMPLETED,
            'Not Started': Status.NOT_STARTED
        };
        return statusMap[status];
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this.dataSource.data);
    }

    checkboxLabel(row?: PeriodicElement): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id}`;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    toggleClass() {
        this.classApplied = !this.classApplied;
        if (!this.classApplied) {
            this.resetForm();
        }
    }

    openEditMode(element: PeriodicElement) {
        this.isEditMode = true;
        
        // Convertir la date au format yyyy-MM-dd pour le datepicker
        const dateParts = element.dueDate.split(' ');
        const months: { [key: string]: string } = {
            'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
            'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
            'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
        };
        const formattedDate = `${dateParts[2]}-${months[dateParts[1]]}-${dateParts[0].padStart(2, '0')}`;

        this.taskForm.patchValue({
            taskName: element.taskName,
            dueDate: formattedDate,
            priority: element.priority,
            status: this.getStatusString(element.status)
        });

        this.classApplied = true;
    }

    getStatusString(status: any): string {
        if (status.inProgress) return 'In Progress';
        if (status.pending) return 'Pending';
        if (status.completed) return 'Completed';
        if (status.notStarted) return 'Not Started';
        return 'Not Started';
    }

    deleteTask(element: PeriodicElement) {
        if (!element.id) return;

        if (confirm('Êtes-vous sûr de vouloir supprimer cette tâche ?')) {
            this.taskService.deleteTask(element.id).subscribe({
                next: () => {
                    this.loadTasks();
                },
                error: (error) => {
                    console.error('Erreur lors de la suppression:', error);
                    alert('Erreur lors de la suppression de la tâche');
                }
            });
        }
    }

onSubmit() {
    console.log('==============================');
    console.log('onSubmit appelé');
    console.log('------------------------------');

    if (this.taskForm.invalid) {
        console.warn('Formulaire invalide:', this.taskForm.value);
        return;
    }

    const formValue = this.taskForm.getRawValue();
    console.log('Valeurs du formulaire:', formValue);
    console.log('isEditMode:', this.isEditMode);
    console.log('currentTaskId:', this.currentTaskId);

    if (this.isEditMode && this.currentTaskId) {
        console.log('--- Mode UPDATE ---');
        console.log(`Edition de la tâche ID: ${this.currentTaskId}`);
        console.log('Données avant update:', formValue);
        this.updateTask(this.currentTaskId, formValue);
    } else {
        console.log('--- Mode CREATE ---');
        console.log('Création d’une nouvelle tâche avec ces données:', formValue);
        this.createTask(formValue);
    }

    console.log('------------------------------');
}

// ==========================
// Méthode de création
// ==========================
createTask(formValue: any) {
    console.log('Mode création activé');
    
    const task: Task = {
        taskName: formValue.taskName,
        dueDate: formValue.dueDate,
        priority: this.reverseMapPriority(formValue.priority),
        status: this.reverseMapStatus(formValue.status)
    };

    console.log('Objet Task préparé pour création:', task);

    this.taskService.createTask(task).subscribe({
        next: (res) => {
            console.log('Réponse du backend après création:', res);
            this.loadTasks();
            this.toggleClass();
        },
        error: (error) => {
            console.error('Erreur lors de la création:', error);
            alert('Erreur lors de la création de la tâche');
        }
    });
}

// ==========================
// Méthode de mise à jour
// ==========================
updateTask(taskId: number, formValue: any) {
    console.log(`Mode édition activé pour l'ID ${taskId}`);

    const task: Task = {
        taskName: formValue.taskName,
        dueDate: formValue.dueDate,
        priority: this.reverseMapPriority(formValue.priority),
        status: this.reverseMapStatus(formValue.status)
    };

    console.log('Objet Task préparé pour update:', task);

    this.taskService.updateTask(taskId, task).subscribe({
        next: (res) => {
            console.log('Réponse du backend après update:', res);
            this.loadTasks();
            this.toggleClass();
        },
        error: (error) => {
            console.error('Erreur lors de la mise à jour:', error);
            alert('Erreur lors de la mise à jour de la tâche');
        }
    });
}


    resetForm() {
        this.taskForm.reset({
            taskName: '',
            dueDate: '',
            priority: 'Medium',
            status: 'Not Started'
        });
        this.taskForm.get('id')?.enable();
        this.isEditMode = false;
        this.currentTaskId = null;
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }
}